import { Routes } from '@angular/router';
import { asmEnabledGuard, b2bEnabledGuard } from '@core/guards/feature-flags.guard';

export const routes: Routes = [
  {
    path: '',
    canMatch: [b2bEnabledGuard],
    loadChildren: () => import('@b2b/b2b.routes').then(mod => mod.B2B_ROUTES),
  },
  {
    path: '',
    canMatch: [asmEnabledGuard],
    loadChildren: () => import('@asm/asm.routes').then(mod => mod.ASM_ROUTES),
  },
  {
    path: '**',
    loadComponent: () => import('@shared/components/not-found/not-found.component').then(mod => mod.NotFoundComponent),
    data: { hasCMSPage: false },
  },
];
